<template>
  <div
    class="zt-chip max-w-full items-center inline-flex cursor-default outline-none overflow-hidden px-4 relative no-underline align-middle text-sm m-1"
    :class="[bgColor, textColor, shape]" :style="[isOutline, isHover]" @mouseover="changeHover(true)"
    @mouseout="changeHover(false)">
    <span class="zt-chip-text items-center inline-flex" :style="{ color: `${isHoverActive ? '#fff' : ''}` }">
      <slot />
    </span>
    <span v-if="closable" class="zt-chip-close flex justify-center items-center cursor-pointer" :class="closeIconSize"
      :style="{ color: `${isHoverActive ? '#fff' : ''}` }" @click="closeChip($event)">
      <zt-icon :name="closeIcon" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'ztChip',
  inheritAttrs: false,
}
</script>


